import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB3-U3-P20-E1',
    audio: 'img/FriendsPlus/Page20/Audio/audio-e1-p20.mp3',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page20/E1/Key/answerKey.png',
    titleImage: '',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page20/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/tieude-e1-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page20/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page20/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/6.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page20/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/8.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page20/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/10.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page20/E1/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page20/E1/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page20/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/14.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page20/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/16.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page20/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/18.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page20/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/20.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page20/E1/21.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/22.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page20/E1/23.jpg' },
        { url: 'img/FriendsPlus/Page20/E1/24.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page20/E1/25.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page20/E1/26.jpg' },
      ],



    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB3-U3-P20-E2',
    audio: '',
    video: '',
    component: D1,
    isAllowSubmit: true,
    maxLength: 1,
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page20/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page20/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page20/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/3.jpg', input: true, answer: "h" },
        { url: 'img/FriendsPlus/Page20/E2/4.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page20/E2/5.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page20/E2/6.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page20/E2/7.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page20/E2/8.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page20/E2/9.jpg' },
      ],
      [
        // Column3  m i l k s h a k e
        { url: 'img/FriendsPlus/Page20/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/11.jpg', input: true, answer: "m" },
        { url: 'img/FriendsPlus/Page20/E2/12.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page20/E2/13.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page20/E2/14.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page20/E2/15.jpg', input: true, answer: "s" },
        { url: 'img/FriendsPlus/Page20/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/17.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page20/E2/18.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page20/E2/19.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page20/E2/20.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page20/E2/21.jpg' },
      ],
      [
        // Column5  p i z z a
        { url: 'img/FriendsPlus/Page20/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/23.jpg', input: true, answer: "p" },
        { url: 'img/FriendsPlus/Page20/E2/24.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/25.jpg', input: true, answer: "z" },
        { url: 'img/FriendsPlus/Page20/E2/26.jpg', input: true, answer: "z" },
        { url: 'img/FriendsPlus/Page20/E2/27.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page20/E2/28.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page20/E2/29.jpg' },
      ],
      [
        // Column7  n o o d l e s
        { url: 'img/FriendsPlus/Page20/E2/30.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/31.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page20/E2/32.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page20/E2/33.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page20/E2/34.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page20/E2/35.jpg', input: true, answer: "l" },
        { url: 'img/FriendsPlus/Page20/E2/36.jpg' },
        { url: 'img/FriendsPlus/Page20/E2/37.jpg', input: true, answer: "s" },
        { url: 'img/FriendsPlus/Page20/E2/38.jpg' },
      ],


    ]
  }
}

export default json;